(function(w){
  function n(v){return String(v||'').replace(/\+/g,' ').trim().replace(/\s+/g,' ').toLowerCase();}
  function m(keys,values){
    try{
      var km={},vm={},ks=keys||[],vs=values||[],i;
      for(i=0;i<ks.length;i++){var k=n(ks[i]);if(k)km[k]=1;}
      for(i=0;i<vs.length;i++){var nv=n(vs[i]);if(nv)vm[nv]=String(vs[i]);}
      if(!Object.keys(km).length||!Object.keys(vm).length)return null;
      var r=null,p=new URLSearchParams(w.location.search||'');
      p.forEach(function(v,k){if(r||!km[n(k)])return;var nv=n(v);if(Object.prototype.hasOwnProperty.call(vm,nv))r={key:k,value:vm[nv]};});
      return r;
    }catch(e){return null;}
  }
  function rm(keys){
    try{
      var p=new URLSearchParams(w.location.search||''),km={},c=false,ks=keys||[],i;
      for(i=0;i<ks.length;i++){var k=n(ks[i]);if(k)km[k]=1;}
      Array.from(p.keys()).forEach(function(k){if(km[n(k)]){p.delete(k);c=true;}});
      if(!c||!w.history||!w.history.replaceState)return;
      var q=p.toString();
      w.history.replaceState(null,'',w.location.pathname+(q?'?'+q:'')+(w.location.hash||''));
    }catch(e){}
  }
  w.SMSQueryDynamicPreselect={norm:n,match:m,remove:rm};
})(window);
